<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="项目">
              <a-select
                style="max-width: 200px;min-width: 100%"
                showSearch
                :disabled="showable"
                placeholder="请选择项目"
                v-decorator="['projectId', {rules: [{required: true, message: '请选择项目'}]}]"
                :options="projectList"
                v-model="queryParam.projectId"
                optionFilterProp="children"
              >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="时间">
              <a-date-picker
                style="max-width: 200px;min-width: 100%"
                @change="onChange"
                v-model="clearDate"></a-date-picker>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-button @click="() => {this.queryPage()}" type="primary">查询</a-button>
            <a-button @click="() => {queryParam = {},clearDate=undefined,queryParam.sign='build'}" style="margin-left: 8px">重置</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button
        v-action="'dailyBuild:buildSubcontract:add'"
        @click="$refs.buildSubcontractAddOrUpdate.init('','add')"
        icon="plus"
        type="primary"
      >新建</a-button>
    </div>
    <s-table
      bordered
      disabled="showable"
      ref="table"
      :data="loadData"
      :columns="columns"
      :rowKey="record => record.id"
    >
      <span slot="action" slot-scope="text,record">
        <div>
          <span v-action="'dailyBuild:buildSubcontract:show'">
            <a @click="$refs.buildSubcontractAddOrUpdate.init(record.id,'show')">详情</a>
          </span>
          <span v-action="'dailyBuild:buildSubcontract:edit'">
            <a-divider type="vertical" />
            <a @click="$refs.buildSubcontractAddOrUpdate.init(record.id,'edit')">修改</a>
          </span>
          <span v-action="'dailyBuild:buildSubcontract:del'">
            <a-divider type="vertical" />
            <a-popconfirm title="是否删除" @confirm="deleteItem(record)" okText="是" cancelText="否">
              <a-icon slot="icon" type="question-circle-o" style="color: red" />
              <a href="javascript:;" style="color: red">删除</a>
            </a-popconfirm>
          </span>
        </div>
      </span>
    </s-table>
    <build-subcontract-add-or-update
      @ok="queryPage"
      ref="buildSubcontractAddOrUpdate"
    />
  </a-card>
</template>
<script>
import moment from 'moment'
import { TableMixin } from '@/mixins/TableMixin'
import { dropProjectByType } from '@/api/project/ProjectInfo'
import { fetchList, delObj } from '@/api/daily/subcontract'
import BuildSubcontractAddOrUpdate from './buildSubcontractAddOrUpdate'

export default {
  name: 'BuildSubcontract',
  components: { BuildSubcontractAddOrUpdate },
  mixins: [TableMixin],
  data () {
    return {
      description: '记录分包出去的项目详细信息与费用',
      projectList: [], // 项目
      showable: false,
      clearDate: undefined,
      queryParam: {
        projectId: undefined,
        date: undefined,
        sign: 'build'
      },
      typeList: [
        {
          label: '分包费用',
          value: 'assessment'
        },
        {
          label: '费用分摊',
          value: 'subcontracting'
        }],
      purchaserQuery: {
        roleCode: 'sx_purchaser'
      },
      loadData: parameter => {
        return fetchList(
          Object.assign(parameter, this.queryParam)
        ).then(res => {
          return res.data
        })
      },
      columns: [
        {
          title: '序号',
          width: '62px',
          customRender: (text, record, index) => {
            return (
              <div>
                {index + 1}
              </div>
            )
          }
        },
        {
          title: '项目',
          dataIndex: 'projectName'
        },
        {
          title: '类型',
          dataIndex: 'type',
          customRender: (text) => {
            this.typeList.forEach(item => {
              if (item.value === text) {
                text = item.label
              }
            })
            return (text)
          }
        },
        {
          title: '日期',
          dataIndex: 'date',
          customRender: (text) => {
            return (
              <div>
                { moment(text).format('YYYY-MM-DD')}
              </div>
            )
          }
        },
        {
          title: '分包商/费用分摊名称',
          dataIndex: 'subcontractor'
        },
        {
          title: '分包结算、支付情况/费用分摊内容',
          dataIndex: 'content'
        },
        {
          title: '分包完成额/费用分摊额',
          dataIndex: 'amount',
          customRender: (text) => {
            return (
              <div style="float:right">
                { text === null ? ' 0.00 ' : Number(text).toFixed(2)}
              </div>
            )
          }
        },
        {
          title: '分包已支付额',
          dataIndex: 'paid',
          customRender: (text) => {
            return (
              <div style="float:right">
                { text === null ? ' 0.00 ' : Number(text).toFixed(2)}
              </div>
            )
          }
        },
        {
          title: '操作',
          width: '200px',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  methods: {
    init () {
      dropProjectByType('build').then(res => {
        this.projectList = res.data
      })
    },
    deleteItem (record) {
      delObj(record.id).then(res => {
        this.$message.info('删除成功')
        this.queryPage()
      })
    },
    onChange (date, dateString) {
      // 格式化日期类
      if (date !== null) {
        this.queryParam.date = moment(date).format('YYYY-MM-DD')
      } else {
        this.queryParam.date = undefined
      }
    }
  },
  created () {
    this.init()
  }
}
</script>
<style scoped>

</style>
